<template>
    <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="px-4 sm:px-8 flex flex-col h-full w-full py-4 sm:py-8">
                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <router-link to="/sponsorship-management"
                            class="opacity-50 hover:opacity-100">Sponsorship</router-link>
                        <span class="mx-2">/</span>
                        <span>Skill Hub</span>
                    </div>
                    <div class="font-bold">Skill Hub</div>
                </div>

                <!-- Sponsorship Dashboard Start -->
                <div class="flex flex-col mt-8">
                    <div class="grid grid-col-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-8">
                        <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">Total</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">{{ totalCount }}</h1>
                                </div>
                            </div>
                        </div>
                        <div v-if="isShowChart('ATHS', atsCount)"
                            class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">ATS</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">{{ atsCount }}</h1>
                                </div>
                                <div class="flex-shrink-0">
                                    <img class="h-8" src="../../assets/images/dashboard/alumni/ATS.png" alt="ATS">
                                </div>
                            </div>
                        </div>
                        <div v-if="isShowChart('ADPOLY', adpolyCount)"
                            class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">ADPOLY</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">{{ adpolyCount }}</h1>
                                </div>
                                <div class="flex-shrink-0">
                                    <img class="h-12" src="../../assets/images/dashboard/alumni/ADPOLY.png"
                                        alt="ADPOLY">
                                </div>
                            </div>
                        </div>
                        <div v-if="isShowChart('FCHS', fchsCount)"
                            class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">FCHS</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">{{ fchsCount }}</h1>
                                </div>
                                <div class="flex-shrink-0">
                                    <img class="h-14" src="../../assets/images/dashboard/alumni/FCHS.png" alt="FCHS">
                                </div>
                            </div>
                        </div>
                        <div v-if="isShowChart('ADVETI', advetiCount)"
                            class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <div class="flex justify-between items-center">
                                <div class="flex-grow flex flex-col">
                                    <p class="text-xl">ADVETI</p>
                                    <h1 v-if="isDashboardLoading" class="h-9 bg-gray-200 animate-pulse mt-1 mr-2"></h1>
                                    <h1 v-else class="text-3xl font-bold mt-1">{{ advetiCount }}</h1>
                                </div>
                                <div class="flex-shrink-0">
                                    <img class="h-16" src="../../assets/images/dashboard/alumni/ADVETI.png"
                                        alt="ADVETI">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-8 mt-8">
                        <div class="bg-white rounded-2xl border shadow-lg px-8 py-6">
                            <h1 class="text-lg font-bold">Sponsorship / Entity</h1>
                            <div v-if="isDashboardLoading" class="wd-380 ht-242-7 flex items-center">
                                <div class="">
                                    <div class="ml-8 wd-216 ht-216 rounded-full bg-gray-200 animate-pulse"></div>
                                </div>
                            </div>
                            <apexchart v-else type="pie" width="380" :options="chartOptions1" :series="series1">
                            </apexchart>
                        </div>
                    </div>

                </div>
                <!-- Sponsorship Dashboard End -->

                <div v-if="!noItems" class="mt-4 flex justify-end items-center">
                    <div v-if="isExportExcel"
                        class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg hover:text-ternary text-white">
                        <base-spinner-with-text class-list="w-4 h-4" text=""
                            text-class-list="text-white"></base-spinner-with-text>
                        <span class="text-xs">Exporting Excel</span>
                    </div>
                    <div v-else @click="generateReport"
                        class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg cursor-pointer hover:text-ternary text-white">
                        <font-awesome-icon :icon="['fas', 'file-excel']" />
                        <span class="text-xs ml-2">Export Excel</span>
                    </div>
                </div>

                <section class="mt-4 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-between items-center flex-wrap">
                        <h1 class="text-base md:text-lg font-semibold text-ternary mb-4">Skill Hub Students List</h1>
                        <div class="flex justify-start items-center flex-wrap">
                            <div class="w-full sm:w-auto mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Entity:</div>
                                <select v-model="filterByEntity" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="item.entity" v-for="(item, index) in filteredEntities" :key="index">
                                        {{ getEntityName(item.entity) }}</option>
                                </select>
                            </div>
                            <div
                                class="w-full sm:w-auto ml-0 sm:ml-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Employer:</div>
                                <select v-model="filterBySponsor" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option :value="item" v-for="(item, index) in sponsorsList" :key="index">{{ item }}
                                    </option>
                                </select>
                            </div>
                            <div
                                class="w-full sm:w-auto ml-0 sm:ml-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Local or Non Local:</div>
                                <select v-model="filterByLocalOrNonLocal" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="Local">Local</option>
                                    <option value="Non Local">Non Local</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="w-full mb-4">
                        <search @on-search="onSearch" class-list="px-4 h-8"></search>
                    </div>

                    <div class="flex justify-start">
                        <div @click.stop="clearAllFilter()"
                            class="px-3 py-1 text-sm border border-red-500 bg-red-500 hover:bg-white text-white hover:text-red-500 rounded-lg cursor-pointer">
                            Clear All Filter</div>
                    </div>

                    <div class="flex flex-col" v-if="$apollo.queries.skill_hubs.loading">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <div class="min-w-full text-left text-sm font-light">
                                        <div class="border-b font-medium dark:border-neutral-500">
                                            <div class="flex">
                                                <div class="px-6 py-2 text-gray-400 w-12 lg:w-16">#</div>
                                                <div class="flex-grow px-6 py-2 text-gray-400">
                                                    <div class="w-32 md:w-auto">Name</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Entity</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Employer</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Skill</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Training Location</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Assessment Status</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Assessment Completion Status</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Assessment Result</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Assessed By</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Assessment Date</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Marks</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Training Hours</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400">
                                                    <div class="w-24 lg:w-40">Registration Date</div>
                                                </div>
                                                <div class="px-6 py-2 text-gray-400 w-24 lg:w-40">Actions</div>
                                            </div>
                                        </div>
                                        <div>
                                            <student-tile-shimmer v-for="(sts, index) in first"
                                                :key="index"></student-tile-shimmer>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="noItems" class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">No skill hub users found!</h1>
                    </div>
                    <div v-else class="flex flex-col">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-left text-sm font-light">
                                        <thead class="border-b font-medium dark:border-neutral-500">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Name</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Entity</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Employer</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Skill</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Training Location</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Assessment Status</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Assessment Completion
                                                    Status</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Assessment Result</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Assessed By</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Assessment Date</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Marks</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Training Hours</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Registration Date</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in filteredItems" :key="index"
                                                class="border-b border-dashed dark:border-neutral-500">
                                                <td class="whitespace-nowrap px-6 py-2 font-medium">{{
                                                    paginatorInfo.firstItem + index }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <div class="flex items-center">
                                                        <div class="flex-shrink-0 mr-3">
                                                            <img @click.stop="openPreviewImgModal(item.student_id, item.entity)"
                                                                class="h-12 w-12 rounded-lg object-cover cursor-pointer"
                                                                :src="getProfilePicture(item.student_id, item.entity)"
                                                                alt="">
                                                        </div>
                                                        <div class="flex-grow flex flex-col">
                                                            <h1 class="text-sm font-semibold flex items-center">
                                                                <span @click.stop="viewStudentProfile(item.student_id)"
                                                                    class="text-heading hover:text-blue-600 hover:underline cursor-pointer">{{
                                                                        item.name_en }}</span>
                                                            </h1>
                                                            <p class="text-xs text-gray-400">{{ item.name_ar }}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ getEntityName(item.entity) }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ item.sponsor }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ item.skill_hubs[0].skill }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    item.skill_hubs[0].training_location }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    item.skill_hubs[0].assessment_status }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    item.skill_hubs[0].assessment_completion_status }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    item.skill_hubs[0].assessment_result }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    item.skill_hubs[0].assessed_by }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    item.skill_hubs[0].assessment_date }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{ item.skill_hubs[0].marks }}
                                                </td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    item.skill_hubs[0].training_hours }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">{{
                                                    getFormattedDate(item.skill_hubs[0].reg_date) }}</td>
                                                <td class="px-6 py-2">
                                                    <div class="flex">
                                                        <div v-if="hasPermission('students-show')"
                                                            @click.stop="viewStudentProfile(item.student_id)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer mr-2">
                                                            <icon-eye
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                        </div>
                    </div>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="previewImageModal" title="" height="50vh" @close="closePreviewImageModal">
                            <img class="h-full w-full object-contain" :src="previewImg" />
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-full-modal v-if="showStudentProfileFullModal" title="Student Profile"
                            @close="closeFullModal">
                            <student-profile :student-id="studentId"></student-profile>
                        </base-full-modal>
                    </transition>

                </section>
            </div>
        </div>
        <div class="h-full flex justify-center items-center" v-if="isExportExcel">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>
    </div>
</template>
<script>
import IconEye from "../../components/icons/IconEye.vue";
import gql from 'graphql-tag';
import Pagination from "../../components/shared/pagination.vue";
import StudentTileShimmer from '../../components/students/StudentTileShimmer.vue';
import StudentProfile from "../student-profile/index.vue";
import xlsx from "xlsx/dist/xlsx.full.min.js";
import { formattedDate } from "../../helpers/utils";
import Search from "../../components/shared/search.vue";
export default {
    name: "skill-hub-index",
    components: {
        IconEye,
        Pagination,
        StudentTileShimmer,
        StudentProfile,
        Search,
    },
    data() {
        return {
            skill_hubs: [],
            first: 10,
            page: 1,
            studentId: null,
            filterByEntity: "",
            filterBySponsor: "",
            filterByLocalOrNonLocal: "",
            previewImageModal: false,
            previewImg: "",
            entities: [],
            sponsorsList: [],
            showStudentProfileFullModal: false,
            isDashboardLoading: false,
            totalCount: 0,
            atsCount: 0,
            adpolyCount: 0,
            fchsCount: 0,
            advetiCount: 0,
            isExportExcel: false,
            isApiCallRecurisive: false,
            generatedReport: [],
            searchText: "",
        };
    },
    created() {
        this.getSponsorsList();
        this.getSkillHubDashboard();
    },
    watch: {
        searchText() {
            this.page = 1;
        },
        skill_hubs(newVal) {
            if (newVal.error) {
                if (newVal.error_code == 403) {
                    this.$router.replace('/no-permission');
                } else if (newVal.error_code == 401) {
                    this.$router.replace('/');
                } else {
                    alert(newVal.message);
                    this.$router.replace('/');
                }
            }
        },
        filterByEntity() {
            this.clearAllFilter('filterByEntity');
            this.page = 1;
            this.getSponsorsList();
            this.getSkillHubDashboard();
        },
        filterBySponsor() {
            this.page = 1;
            this.getSkillHubDashboard();
        },
        filterByLocalOrNonLocal() {
            this.page = 1;
            this.getSkillHubDashboard();
        },
    },
    computed: {
        noItems() {
            if (!this.$apollo.queries.skill_hubs.loading && this.filteredItems.length <= 0) {
                return true;
            } else {
                return false;
            }
        },
        filteredItems() {
            return this.skill_hubs.data;
        },
        paginatorInfo() {
            return this.skill_hubs.paginatorInfo;
        },
        role() {
            return this.$store.getters.role;
        },
        filteredEntities() {
            if (this.entities.data && this.entities.data.length > 0) {
                return this.entities.data;
            } else {
                return [];
            }
        },
        series1() {
            if (this.filterByEntity == 'ATHS') {
                return [this.atsCount];
            } else if (this.filterByEntity == 'ADPOLY') {
                return [this.adpolyCount];
            } else if (this.filterByEntity == 'FCHS') {
                return [this.fchsCount];
            } else if (this.filterByEntity == 'ADVETI') {
                return [this.advetiCount];
            } else {
                let count = [];
                if (this.atsCount > 0) {
                    count.push(this.atsCount);
                }
                if (this.adpolyCount > 0) {
                    count.push(this.adpolyCount);
                }
                if (this.fchsCount > 0) {
                    count.push(this.fchsCount);
                }
                if (this.advetiCount > 0) {
                    count.push(this.advetiCount);
                }
                return count;
            }
        },
        chartOptions1() {
            const labels = this.getLabelBasedOnEntity();
            return {
                chart: {
                    width: 380,
                    type: 'pie',
                },
                labels: labels,
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 200
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }
                ]
            }
        },
    },
    apollo: {
        entities() {
            return {
                query: gql`query GetEntityList {
                    entities {
                        data {
                            entity
                        }
                    }
                }`,
                fetchPolicy: 'cache-and-network',
            }
        },
        skill_hubs() {
            return {
                query: gql`query GetAllSkillHubs($first: Int!, $page: Int!, $entity: String, $sponsor: String, $local_or_non_local: String, $search: String) {
                    skill_hubs(first: $first, page: $page, entity: $entity, sponsor: $sponsor, local_or_non_local: $local_or_non_local, search: $search) {
                      error
                      error_code
                      data {
                        student_id
                        name_en
                        entity
                        sponsor
                        skill_hubs {
                            entity
                            skill
                            last_school_name
                            training_location
                            assessment_status
                            assessment_completion_status
                            assessment_result
                            assessed_by
                            assessment_date
                            marks
                            training_hours
                            reg_date
                        }
                      }
                      paginatorInfo {
                          count
                          currentPage
                          firstItem
                          hasMorePages
                          lastItem
                          lastPage
                          perPage
                          total
                      }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        entity: this.filterByEntity,
                        local_or_non_local: this.filterByLocalOrNonLocal,
                        sponsor: this.filterBySponsor,
                        search: this.searchText,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        onSearch(searchText) {
            this.searchText = searchText;
        },
        async getSponsorsList() {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                            query GetSponsorsList($student_status: String, $entity: String) {
                                getSponsorsList(student_status: $student_status, entity: $entity)
                            }
                        `,
                    variables: {
                        student_status: 'AS',
                        entity: this.filterByEntity,
                    },
                    fetchPolicy: 'network-only',
                });
                this.sponsorsList = data.getSponsorsList;
            } catch (error) {
                console.log(error);
            }
        },
        getFormattedDate(date) {
            return formattedDate(date);
        },
        clearAllFilter(filterName = '') {
            if (!filterName) {
                this.filterByEntity = "";
            }
            this.filterBySponsor = "";
            this.filterByLocalOrNonLocal = "";
        },
        getLabelBasedOnEntity() {
            if (this.filterByEntity == 'ATHS') {
                return ['ATS'];
            } else if (this.filterByEntity == 'ADPOLY') {
                return ['ADPOLY'];
            } else if (this.filterByEntity == 'FCHS') {
                return ['FCHS'];
            } else if (this.filterByEntity == 'ADVETI') {
                return ['ADVETI'];
            } else {
                let labesls = [];
                if (this.adpolyCount > 0) {
                    labesls.push('ADPOLY');
                }
                if (this.fchsCount > 0) {
                    labesls.push('FCHS');
                }
                if (this.advetiCount > 0) {
                    labesls.push('ADVETI');
                }
                return labesls;
            }
        },
        async getSkillHubDashboard() {
            this.isDashboardLoading = true;
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                        query GetSkillHubDashboard($entity: String, $sponsor: String, $local_or_non_local: String) {
                            getSkillHubDashboard(entity: $entity, sponsor: $sponsor, local_or_non_local: $local_or_non_local) {
                                data {
                                    total_count
                                    ats_count
                                    adpoly_count
                                    fchs_count
                                    adveti_count
                                }
                            }
                        }
                    `,
                    variables: {
                        entity: this.filterByEntity,
                        sponsor: this.filterBySponsor,
                        local_or_non_local: this.filterByLocalOrNonLocal,
                    },
                    fetchPolicy: 'network-only',
                });

                const skillHubDashboardData = data.getSkillHubDashboard.data;

                this.totalCount = skillHubDashboardData.total_count;
                this.atsCount = skillHubDashboardData.ats_count;
                this.adpolyCount = skillHubDashboardData.adpoly_count;
                this.fchsCount = skillHubDashboardData.fchs_count;
                this.advetiCount = skillHubDashboardData.adveti_count;
            } catch (error) {
                console.log(error);
            }
            this.isDashboardLoading = false;
        },
        getEntityName(entity) {
            if (entity == 'ATHS') {
                return "ATS";
            } else {
                return entity;
            }
        },
        isShowChart(entity, count) {
            if (this.filterByEntity == "") {
                if (count == 0) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return this.filterByEntity == entity;
            }
        },
        setPage(page) {
            this.page = page;
        },
        getProfilePicture(studentId, entity) {
            return `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
        },
        openPreviewImgModal(studentId, entity) {
            this.previewImageModal = true;
            this.previewImg = `https://www.iat.ac.ae/sis/Integrations/Get_Student_Image/Q4tphjXBanCMiro8Kpfbi1QEU5qZb01uWtpkQlpfet8/${studentId}/${entity}`;
        },
        closePreviewImageModal() {
            this.previewImageModal = false;
            this.previewImg = "";
        },
        hasPermission(crudName) {
            if (this.role == 'superadmin') {
                return true;
            } else {
                const permissions = this.$store.getters.permissions;
                const permissionsArray = permissions.split(",");
                if (permissionsArray.includes(crudName)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        closeFullModal() {
            this.showStudentProfileFullModal = false;
            this.studentId = null;
        },
        viewStudentProfile(studentId) {
            this.studentId = studentId;
            this.showStudentProfileFullModal = true;
        },
        async generateReport() {
            var page = 1;
            var limit = 200;
            this.isExportExcel = true;
            this.isApiCallRecurisive = true;
            while (this.isApiCallRecurisive) {
                const responseData = await this.fetchForExporting(page, limit);
                if (responseData.data.length > 0) {
                    this.generatedReport.push(
                        ...responseData.data.map((obj) => {
                            return {
                                student_id: obj.student_id,
                                eid: obj.eid,
                                name_en: obj.name_en,
                                name_ar: obj.name_ar,
                                entity: this.getEntityName(obj.entity),
                                campus: obj.campus_code,
                                program_name: this.getSpecialization(obj.entity, obj.study_program, obj.program_name, obj.program_code, obj.cluster_e),
                                local_or_non_local: obj.local_or_non_local,
                                sponsor: obj.sponsor,
                                skill: obj.skill_hubs[0].skill,
                                last_school_name: obj.skill_hubs[0].last_school_name,
                                training_location: obj.skill_hubs[0].training_location,
                                assessment_status: obj.skill_hubs[0].assessment_status,
                                assessment_completion_status: obj.skill_hubs[0].assessment_completion_status,
                                assessment_result: obj.skill_hubs[0].assessment_result,
                                assessed_by: obj.skill_hubs[0].assessed_by,
                                assessment_date: obj.skill_hubs[0].assessment_date,
                                marks: obj.skill_hubs[0].marks,
                                training_hours: obj.skill_hubs[0].training_hours,
                                reg_date: this.getFormattedDate(obj.skill_hubs[0].reg_date),
                            };
                        })
                    );
                    page++;
                } else {
                    this.isApiCallRecurisive = false;
                    break;
                }
            }
            this.exportToExcel("Skill_Hub_Students");
        },
        async fetchForExporting(pageNo = 1, limitSize = 50) {
            try {
                const { data } = await this.$apollo.query({
                    query: gql`
                    query GenerateSkillHubStudentsReport(
                        $page: Int
                        $limit: Int
                        $entity: String
                        $sponsor: String
                        $local_or_non_local: String
                        $search: String
                    ) {
                    generateSkillHubStudentsReport(
                        page: $page
                        limit: $limit
                        entity: $entity
                        sponsor: $sponsor
                        local_or_non_local: $local_or_non_local
                        search: $search
                    ) {
                        error
                        error_code
                        message
                        data {
                            student_id
                            eid
                            name_en
                            name_ar
                            entity
                            campus_code
                            program_name
                            study_program
                            program_code
                            cluster_e
                            local_or_non_local
                            sponsor
                            skill_hubs {
                                entity
                                skill
                                last_school_name
                                training_location
                                assessment_status
                                assessment_completion_status
                                assessment_result
                                assessed_by
                                assessment_date
                                marks
                                training_hours
                                reg_date
                            }
                        }
                    }
                    }
                `,
                    fetchPolicy: "network-only",
                    variables: {
                        page: pageNo,
                        limit: limitSize,
                        entity: this.filterByEntity,
                        sponsor: this.filterBySponsor,
                        local_or_non_local: this.filterByLocalOrNonLocal,
                        search: this.searchText,
                    },
                });

                const responseData = data.generateSkillHubStudentsReport;
                return responseData;
            } catch (error) {
                console.log(error.message);
            }
        },
        exportToExcel(reportName) {
            const XLSX = xlsx;

            const header = [
                "STUDENT ID",
                "EID",
                "NAME IN ENGLISH",
                "NAME IN ARABIC",
                "ENTITY",
                "CAMPUS",
                "PROGRAM NAME",
                "LOCAL OR NON LOCAL",
                "SPONSOR",
                "SKILL",
                "LAST SCHOOL NAME",
                "TRAINING LOCATION",
                "ASSESSMENT STATUS",
                "ASSESSMENT COMPLETION STATUS",
                "ASSESSMENT RESULT",
                "ASSESSED BY",
                "ASSESSMENT DATE",
                "MARKS",
                "TRAINING HOURS",
                "REGISTRATION DATE",
            ];

            const worksheet = XLSX.utils.json_to_sheet(this.generatedReport);

            worksheet["A1"] = { v: header[0], t: "s" };
            worksheet["B1"] = { v: header[1], t: "s" };
            worksheet["C1"] = { v: header[2], t: "s" };
            worksheet["D1"] = { v: header[3], t: "s" };
            worksheet["E1"] = { v: header[4], t: "s" };
            worksheet["F1"] = { v: header[5], t: "s" };
            worksheet["G1"] = { v: header[6], t: "s" };
            worksheet["H1"] = { v: header[7], t: "s" };
            worksheet["I1"] = { v: header[8], t: "s" };
            worksheet["J1"] = { v: header[9], t: "s" };
            worksheet["K1"] = { v: header[10], t: "s" };
            worksheet["L1"] = { v: header[11], t: "s" };
            worksheet["M1"] = { v: header[12], t: "s" };
            worksheet["N1"] = { v: header[13], t: "s" };
            worksheet["O1"] = { v: header[14], t: "s" };
            worksheet["P1"] = { v: header[15], t: "s" };
            worksheet["Q1"] = { v: header[16], t: "s" };
            worksheet["R1"] = { v: header[17], t: "s" };
            worksheet["S1"] = { v: header[18], t: "s" };
            worksheet["T1"] = { v: header[19], t: "s" };

            worksheet["!cols"] = [
                { width: 40 },
                { width: 40 },
                { width: 30 },
                { width: 30 },
                { width: 20 },
                { width: 20 },
                { width: 40 },
                { width: 40 },
                { width: 20 },
                { width: 20 },
                { width: 40 },
                { width: 40 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 40 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
            XLSX.writeFile(workbook, `${reportName}.xlsx`);
            this.generatedReport = [];
            this.isExportExcel = false;
            this.isApiCallRecurisive = false;
        },
        getSpecialization(entity, studyProgram, programName, programCode, clusterE) {
            let specialization = "";
            if (entity == 'ATHS') {
                if (clusterE) {
                    specialization = clusterE;
                } else if (programName) {
                    specialization = programName;
                } else if (studyProgram) {
                    specialization = studyProgram;
                } else {
                    specialization = programCode;
                }
            } else {
                if (programName) {
                    specialization = programName;
                } else if (studyProgram) {
                    specialization = studyProgram;
                } else {
                    specialization = programCode;
                }
            }
            return specialization;
        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

body.loading {
    filter: blur(5px);
}

#loading-overlay {
    background-color: rgba(0, 0, 0, 0.25);
}

@responsive {
    .wd-380 {
        width: 380px;
    }

    .ht-242-7 {
        height: 242.7px;
    }

    .wd-216 {
        width: 216px;
    }

    .ht-216 {
        height: 216px;
    }

    .ht-350 {
        height: 350px;
    }

    .ht-430 {
        height: 430px;
    }

    .ht-60-vh {
        height: 60vh;
    }

    .ht-700 {
        height: 700px;
    }
}

.text-map-color {
    color: #09306b;
}

.vue-world-map {
    height: 60vh;
}

@media only screen and (max-width: 1023px) {
    .vue-world-map {
        height: 100%;
    }
}
</style>